import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// De-duplicate an array of documents by a stable key (default `id`).
// Order-preserving — later occurrences win, matching Mongo's find() semantics
// so any freshly-amended SO / Item / etc. surfaces its newest snapshot.
// Used everywhere we hydrate `<Select>` options to kill React duplicate-key
// warnings on amended SOs like `SO-26-27-00001/00002` (Feb 2026).
export function dedupById(list, key = "id") {
  if (!Array.isArray(list)) return [];
  const seen = new Map();
  for (const item of list) {
    if (item && item[key] != null) seen.set(item[key], item);
  }
  return Array.from(seen.values());
}
